export const PAYMENT_REQUEST_ADMIN = 'PAYMENT_REQUEST_ADMIN';
export const PAYMENT_SUCCESS_ADMIN = 'PAYMENT_SUCCESS_ADMIN';
